// frontend/src/pages/GamePage.jsx

import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DiceRoller from '../components/DiceRoller';
import '../styles/GamePage.css';


function GamePage({ character, messages, setMessages }) {
  const [playerInput, setPlayerInput] = useState('');
  const [awaitingRoll, setAwaitingRoll] = useState(false);

  const navigate = useNavigate();

  const storyBoxRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token !== process.env.REACT_APP_AUTH_TOKEN) {
      navigate('/');
    }
  }, []);
  
  useEffect(() => {
    if (storyBoxRef.current) {
      storyBoxRef.current.scrollTo({
        top: storyBoxRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  
    // Check if AI asked for a roll
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1];
  
      if (
        lastMessage.sender === 'AI' &&
        (
          lastMessage.text.toLowerCase().includes('roll now and tell me the result') ||
          lastMessage.text.toLowerCase().includes('roll for initiative')
        )
      ) {
        setAwaitingRoll(true);
      }
    }
  }, [messages]);
  

    
  

  // Safety: if somehow no character info, send back to start
  if (!character) {
    navigate('/');
    return null;
  }
  

  const sendMessage = async () => {
    if (!playerInput.trim()) return;
  
    // Add player's message first
    setMessages(prev => [...prev, { sender: 'Player', text: playerInput }]);
    
    setPlayerInput('');
  
    // Add temporary "typing..." AI message
    setMessages(prev => [...prev, { sender: 'DM', text: "..." }]);
  
    // Wait 1 second (simulate AI thinking)
    setTimeout(async () => {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/play`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ playerInput })
      });
      const data = await res.json();
  
      // Replace the last message ("...") with the real AI response
      setMessages(prev => {
        const updated = [...prev];
        updated[updated.length - 1] = { sender: 'AI', text: data.response };
        return updated;
      });
    }, 1000);
  };

  return (
    <div className="game-container">
      <h1>Adventure Time!</h1>
      <div className="story-box" ref={storyBoxRef}>
        {messages.map((m, idx) => (
        <div key={idx} className={m.sender === 'Player' ? 'player-msg' : 'ai-msg'}>
          <strong>{m.sender}:</strong>{' '}
          {m.text === '...' ? (
            <span className="typing-dots">
              <span>.</span><span>.</span><span>.</span>
            </span>
          ) : (
            m.text
          )}
        </div>
      ))}
      </div>
      {awaitingRoll && (
        <DiceRoller onRollComplete={(roll) => {
          // Immediately send the roll as player action
          setMessages(prev => [...prev, { sender: 'Player', text: `I rolled a ${roll}` }]);
          
          fetch(`${process.env.REACT_APP_BACKEND_URL}/api/play`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ playerInput: `I rolled a ${roll}` })
          })
          .then(res => res.json())
          .then(data => {
            setMessages(prev => [...prev, { sender: 'AI', text: data.response }]);
          })
          .catch(err => {
            console.error("Error sending roll:", err);
          });
        
          setAwaitingRoll(false); // Hide dice roller after roll
        }} />        
      )}
      {!awaitingRoll && (
        <>
          <textarea
        value={playerInput}
        onChange={e => setPlayerInput(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
        placeholder="What do you do?"
        rows={1}
          />
          <button onClick={sendMessage}>Send</button>
        </>
      )}
    </div>
  );
  
}

export default GamePage;
